import React from "react";
import PropTypes from "prop-types";
import "./RecruteurCard.scss";
import { useLocation } from "react-router-dom";
import { truncate } from "Services/functions";
import { FaLinkedin, FaRegEnvelope, FaRegAddressBook } from "react-icons/fa";
import neutralUser from "assets/neutralUser.png";

const RecruteurCard = (props) => {
  return (
    <div
      className={
        useLocation().pathname == "/" ||
        useLocation().pathname == "/profil" ||
        useLocation().pathname == "/offres" ||
        useLocation().pathname == "/depot-offre" ||
        useLocation().pathname == "/annuaire" ||
        useLocation().pathname == "/gestion-offre"
          ? "offre cardHover"
          : "offre"
      }
    >
      <div className="annuaire_etudiant__image">
        <span>
          {props.prenom} {props.nom}{" "}
        </span>
        <div className="annuaire_etudiant__image__logo">
          {props.image == "image1" && (
            <img
              src={props.imageUrl ? props.imageUrl : neutralUser}
              alt="Logo de l'entreprise"
              title="Logo de l'entreprise"
            />
          )}
        </div>
      </div>
      <div className="annuaire_etudiant__container">
        <div className="annuaire_etudiant__container__description">
          <div className="annuaire_etudiant__container__description__title">
            <div className="annuaire_etudiant__container__description__title__item">
              <label>Fonction :</label>
              <p>{truncate(props.title, 26)}</p>
            </div>
            <div className="annuaire_etudiant__container__description__title__item">
              <label>
                <FaRegEnvelope />
                Adresse mail :
              </label>
              <p>
                {props.mailPublic ? (
                  props.email ? (
                    <a href={`mailto:${props.email && props.email}`}>
                      {" "}
                      {props.email}
                    </a>
                  ) : (
                    "Non renseignée"
                  )
                ) : (
                  "Indisponible"
                )}
              </p>
            </div>
            <div className="annuaire_etudiant__container__description__title__item">
              <label>
                <FaRegAddressBook />
                Tel :
              </label>
              <p>
                {props.phonePublic
                  ? props.telephone
                    ? props.telephone
                    : "Non renseigné"
                  : "Indisponible"}
              </p>
            </div>

            {props.linkedin && (
              <FaLinkedin className="linkedin" size={"2rem"} />
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

RecruteurCard.propTypes = {
  title: PropTypes.string,
  nom: PropTypes.string,
  prenom: PropTypes.string,
  telephone: PropTypes.string,
  linkedin: PropTypes.bool,
  email: PropTypes.bool,
  image: PropTypes.string,
  phonePublic: PropTypes.bool,
  mailPublic: PropTypes.bool,
  imageUrl: PropTypes.string,
};

export default RecruteurCard;
